<script>
export default {
  name: "VPicture",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<template>
  <picture class="picture">
    <source
      v-if="data.src.xl"
      media="(min-width: 1200px)"
      :srcset="data.src.xl"
    />
    <source
      v-if="data.src.lg"
      media="(min-width: 992px)"
      :srcset="data.src.lg"
    />
    <source
      v-if="data.src.sm"
      media="(min-width: 576px)"
      :srcset="data.src.sm"
    />
    <img
      :src="data.src.xs || data.src.sm || data.src.lg || data.src.xl"
      :alt="data.alt"
    />
  </picture>
</template>
